export const ViewHelperTexts = {
    "data_source_mapping": {
        "view": "Transaction to load and bind data to the entire view.",
        "section": "Transaction to load and bind data to the selected section.",
        "chat": "Transaction to fetch and load chat history for the widget.",
        "control-button": "Transaction to load and bind data to Button widget",
        "control-switch": "Transaction to load and bind data to Switch widget",
        "control-slider": "Transaction to load and bind data to Slider widget",
        "control-joystick": "Transaction to load and bind data to Joystick widget",
        "chart-heatmap": "Transaction to load and bind data to Chart Heatmap widget",
        "chart-bar": "Transaction to load and bind data to Chart Bar widget",
        "chart-line": "Transaction to load and bind data to Chart Line widget",
        "chart-stackbar": "Transaction to load and bind data to Chart Stackbar widget",
        "chart-pie": "Transaction to load and bind data to Chart Pie widget",
        "chart-pie-radial": "Transaction to load and bind data to Chart Pie Radial widget",
        "chart-rangeplot": "Transaction to load and bind data to Chart Rangeplot widget",
        "chart-ratiobar": "Transaction to load and bind data to Chart Ratiobar widget",
        "chart-scatter": "Transaction to load and bind data to Chart Scatter widget",
        "status": "Transaction to load and bind data to Status widget",
        "gauge": "Transaction to load and bind data to Gauge widget",
        "string": "Transaction to load and bind data to String widget",
        "counter": "Transaction to load and bind data to Counter widget",
        "chart-geomap": "Transaction to load and bind data to Chart Geomap widget",
        "compass": "Transaction to load and bind data to Compass widget",
        "image": "Transaction to load and bind data to Image widget",
        "video": "Transaction to load and bind data to Video widget",
        "model-3d": "Transaction to load and bind data to 3D Model widget",
        "scene-3d": "Transaction to load and bind data to 3D Scene widget",
        "table": "Transaction to load and bind data to Table widget",
        "html_form": "Transaction to load and bind data to Html Form widget",
        "image-map": "Transaction to load and bind data to Image Map widget"
    },
    "view_prompt": {
       "fetch_transaction":  "Transaction to fetch and display policy-related information in the view.",
       "accept_transaction":  "Transaction to trigger when the user accepts the license criteria.",
       "deny_transaction": "Transaction to trigger when the user denies the license criteria (optional)."
    },
    "form_operations": {
      "getter": "Transaction to fetch and populate data into the form fields.",
      "setter": "Transaction to trigger when the form is submitted.",
    },
    "chat_box_widget": {
      "setter": "Transaction to trigger when the query is submitted.",
      "link_tracker": "Transaction to trigger that tracks and notify link clicks within chat messages."  
    },
    "button_widget": {
      "getter": "Transaction to fetch and populate data into the form fields.",
      "setter": "Transaction triggered when the Submit button is clicked."
    },
    "switch_widget": {
      "setter": "Transaction to trigger when the switch state is changed."
    },
    "slider_widget": {
      "setter": "Transaction to trigger when the slider value is changed."
    },
    "joystick_widget": {
      "setter": "Transaction to trigger when the joystick value is changed."
    },
    "imagemap_widget": {
      "area_operation": "Transaction to trigger when an image-map area is clicked."
    },
    "table_operation": {
      "getter": "Transaction to fetch and populate data into the form fields.",
      "setter": "Transaction triggered when the Submit button is clicked."
    },
    "table_row_operation": {
      "getter": "Transaction to fetch and populate data into the form fields.",
      "setter": "Transaction triggered when the Submit button is clicked."
    },
  }
  